<template>
    <div class="content">
        <p>
            This is a collection of calculators related to Guild Wars 2.
            Choose from the menu on the left side.
        </p>
        <p>
            If you have an idea for a new one, let us know on
            <router-link to="/discord">our discord server</router-link>.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'calculators-about',
    }
</script>

<style>
</style>
